var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"streak-and-goal-container grid-row"},[_c('widget-card',[_c('streak-widget',{attrs:{"flashcard-stats":_vm.flashcardStats,"streak-info-body":_vm.streakInfoBody}})],1),_vm._v(" "),_c('widget-card',[_c('goal-widget',{attrs:{"flashcard-stats":_vm.flashcardStats}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }